export default "__VITE_ASSET__DbRjMK2y__"